import {useContext} from "react";
import AuthContext from "context/AuthContext";
import LineEChartMultiple from "./waste/LineEChartMultiple";
import LineEChartMultipleBridge from "./bridge/LineEchartMultipleBridge";

const LineEchartManager = ({measuresData, translations, alerts, chartRef, max, min}) => {
    const {panel} = useContext(AuthContext);

    switch (panel.panel_type) {
        case "b":
            return (
                <LineEChartMultipleBridge
                    measuresData={measuresData}
                    translations={translations}
                    alerts={alerts}
                    chartRef={chartRef}
                    max={max}
                    min={min}
                />
            );
        default:
            return (
                <LineEChartMultiple
                    measuresData={measuresData}
                    translations={translations}
                    alerts={alerts}
                    chartRef={chartRef}
                    max={max}
                    min={min}
                />
            );
    }
};

export default LineEchartManager;
